import UserService from "src/services/UserService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	UPLOAD_IMAGE: "user/edit",
	CHANGE: "user/change",
  SELECT_MOSAD: "user/selectMosad"
};
export const params = {
	name: "",
	last_name: "",
	email: "",
	email_verified_at: "",
	password: "",
	role: 2,
	organization_id: ""
};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.user,
 @property  {array}  modules.users
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		[types.CHANGE](context,passwords) {
			return UserService.changePassword(passwords).then(response => response);
		},
    [types.SELECT_MOSAD](context,mosad) {
      return UserService.selectMosad(mosad).then(response => response);
    }
	},
	types: types
};
export default ModuleCreator("user", UserService, module, types, params);
